import type { ReactNode } from "react";
import { cx } from "./util";

export interface PanelProps {
  /** Rendered in the header bar beside the stamped three-dot marker. */
  title: ReactNode;
  /** Right-aligned header slot — counts, badges, a small action. */
  aside?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Slide the whole panel in on mount. */
  animate?: boolean;
}

/**
 * L1 header over an L1.5 periwinkle body. The `::before` marker on
 * `.panel-header` is the stamped three-dot glyph — do not add an icon.
 */
export function Panel({ title, aside, children, className, animate = true }: PanelProps) {
  return (
    <section className={cx("panel", animate && "bd-slide-in", className)}>
      <header className="panel-header">
        <span className="t-label grow truncate">{title}</span>
        {aside ? <span className="cluster">{aside}</span> : null}
      </header>
      <div className="panel-body">{children}</div>
    </section>
  );
}
